import React, { createRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as cocoSsd from "@tensorflow-models/coco-ssd";
import * as tf from "@tensorflow/tfjs";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  makeStyles,
  Typography,
} from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
const GRANTED_CLASSES = ["dog"];

const useStyles = makeStyles((theme) => ({
  dangerHeader: {
    backgroundColor: theme.palette.error.main,
    marginInline: 1,
    paddingInline: 5,
  },
  caption: {
    fontSize: "0.7rem",
    color: "#ffffff",
    textAlign: "center",
  },
}));
function DogMedia(props) {
  const classes = useStyles();
  const imgRef = createRef();

  const [src, setSrc] = useState(null);
  const [model, setModel] = useState(null);
  const [detections, setDetections] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const [detecting, setDetecting] = useState(true);

  const loadModel = async () => {
    try {
      const _model = await cocoSsd.load();
      setModel(_model);
      setDetections(null);
      console.log("Model loaded successfully!");
    } catch (err) {
      console.error(err);
      console.error("failed load model");
    }
  };
  useEffect(() => {
    if (FileReader && props.file) {
      var fr = new FileReader();
      fr.onload = function () {
        setSrc(fr.result);
      };
      fr.readAsDataURL(props.file.file);
    }
    if (props.mode === "detection" && !model) {
      tf.ready().then(() => {
        loadModel();
      });
    }
  }, [props.mode, props.file, model]);
  useEffect(() => {
    if (
      props.mode === "detection" &&
      src &&
      imgRef.current &&
      model &&
      !detections
    ) {
      const img = document.getElementById(props.file?.id);
      model.detect(img).then((_detections) => {
        setDetecting(false);
        setDetections(_detections);
        if (
          !_detections.some((detect) => GRANTED_CLASSES.includes(detect.class))
        ) {
          setIsValid(false);
          // Emits event of invalid media
          props.onInvalid && typeof props.onInvalid==="function" && props.onInvalid() 
        }
      });
    }
  }, [imgRef, src, model, props.file, props.mode, detections]);
  return src ? (
    <Card variant="outlined" elevation={0} style={props.styles}>
      {!isValid && (
        <CardHeader
          color="red"
          className={classes.dangerHeader}
          title={
            <Box
              display="flex"
              alignContent="center"
              alignItems={"center"}
              gridGap={3}
            >
              <ErrorIcon style={{ color: "#fff" }} fontSize="small" />

              <Typography
                variant="caption"
                color="error"
                align="center"
                className={classes.caption}
              >
                This image does not contain a dog
              </Typography>
            </Box>
          }
        ></CardHeader>
      )}

      <CardContent style={{ position: "relative" }}>
        {detecting && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridGap={2}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "50%",
              zIndex: 5,
            }}
          >
            <CircularProgress />
            <Typography variant="caption" color="textSecondary">
              Scanning Image...
            </Typography>
          </Box>
        )}
        <img
          id={`${props.file?.id}`}
          ref={imgRef}
          src={src}
          alt="Preview Dog Content"
          width={"100%"}
          style={{ opacity: detecting ? 0.4 : 1 }}
        />
      </CardContent>
    </Card>
  ) : null;
}

DogMedia.propTypes = {
  file: PropTypes.object.isRequired,
  mode: PropTypes.oneOf(["display", "detection"]),
  onInvalid: PropTypes.func,
};
DogMedia.defaultProps = {
  mode: "display",
  styles: {
    width: "100%",
  },
};

export default DogMedia;
